import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import SuspenseLoader from 'src/components/SuspenseLoader';

export const Loader = (Component) => (props) =>
(
    <Suspense fallback={<SuspenseLoader />}>
        <Component {...props} />
    </Suspense>
);

const Dashboard = Loader(lazy(() => import('src/content/dashboards/ccs/agent/Learning')));
const Followup = Loader(lazy(() => import('src/content/followup')));
const Reports = Loader(lazy(() => import('src/content/reports/agent')));



const agentRoutes = [
    {
        path: '',
        element: <Navigate to="dashboard" replace />
    },
    {
        path: 'dashboard',
        element: <Dashboard />
    },
    {
        path: 'followup',
        element: <Followup />
    },
    {
        path: 'report',
        element: <Reports />
    }

];

export default agentRoutes;